import type { SqlImport } from '@/services/db/sql-import/entity';
import { generatePath } from '@/services/router/generate-path';

const SNOWFLAKE_DATABASE_TYPE = 'snowflake';
const PASSWORD_AUTH_TYPE = 'password';
const UNNAMED_CONFIGURATION = 'Unnamed Configuration';

export interface SnowflakePasswordConfig {
  name: string;
  href: string;
}

/**
 * The active Snowflake imports still using password authentication, mapped to the
 * per-configuration links the warning banner lists. Takes the Snowflake imports the query
 * already grouped by database. Returns an empty array when none apply; the banner renders
 * only when at least one configuration is returned. The links target the embedded sql-sync
 * pages.
 */
export function snowflakePasswordConfigs(
  snowflakeImports: readonly SqlImport[],
  workspaceId: string,
): SnowflakePasswordConfig[] {
  return snowflakeImports
    .filter((sqlImport) => sqlImport.active && sqlImport.database?.auth_type === PASSWORD_AUTH_TYPE)
    .map((sqlImport) => ({
      name: sqlImport.database?.name ?? UNNAMED_CONFIGURATION,
      href: generatePath('/workspaces/:workspaceId/journeys/integrations/sql-sync/:type/:sqlImportId', {
        workspaceId,
        type: SNOWFLAKE_DATABASE_TYPE,
        sqlImportId: sqlImport.id,
      }),
    }));
}

/** Link to the Snowflake sql-sync index — the banner's "Update database configuration" action. */
export function snowflakeConfigActionHref(workspaceId: string): string {
  return generatePath('/workspaces/:workspaceId/journeys/integrations/sql-sync/:type', {
    workspaceId,
    type: SNOWFLAKE_DATABASE_TYPE,
  });
}
